import * as R from "ramda";
import React from "react";
export var isString = function(value) {
    return typeof value === "string";
};
export var isNumber = function(value) {
    return typeof value === "number";
};
export var isObject = function(item) {
    return R.type(item) === "Object" && item !== null;
};
export var isArrayOfStrings = function(value) {
    return Array.isArray(value) && value.every(function(item) {
        return typeof item === "string";
    });
};
export var isUUID = function(value) {
    if (!isString(value)) return false;
    var regexExp = /^[0-9a-f]{8}\b-[0-9a-f]{4}\b-[0-9a-f]{4}\b-[0-9a-f]{4}\b-[0-9a-f]{12}$/gi;
    return regexExp.test(value);
};
export var isJSXElement = function(child) {
    return React.isValidElement(child);
};
export var hasAllRequiredFields = function(obj, requiredFields) {
    return requiredFields.every(function(field) {
        return Object.hasOwn(obj, field);
    });
};
export var isInputEvent = function(e) {
    var currentTarget = e.currentTarget;
    return isNotEmpty(currentTarget) && "value" in currentTarget;
};
export var isEventTargetElement = function(e) {
    var target = e.target;
    return isNotEmpty(target) && "tagName" in target;
};
export var isNotEmpty = function(value) {
    return value !== null && value !== undefined;
};
export var isGridElement = function(element) {
    return isNotEmpty(element) && "selectItem" in element;
};
// Validate API exceptions
export var isErrorObject = function(data) {
    return R.is(Object, data) && (R.has("message", data) && !R.isEmpty(data.message) || R.has("response", data) && !R.isEmpty(data.response));
};
export var isHttpError = function(data) {
    return R.is(Object, data) && R.has("code", data) && [
        "String",
        "Number"
    ].includes(R.type(data.code)) && !R.isEmpty(data.code);
};
export var isParsingError = function(data) {
    return R.is(Object, data) && R.has("errors", data) && Array.isArray(data.errors) && !R.isEmpty(data.errors);
};
// Marketplace validators
export var isMarketplaceProject = function(data) {
    return R.is(Object, data) && R.hasPath(R.split(".", "Instances.0.ActiveDeployment.Package.ProductVersions.0.Product"), data);
};
export var isMarketplaceDeployment = function(data) {
    return R.is(Object, data) && R.hasPath(R.split(".", "Package.ProductVersions.0"), data);
};

//# sourceMappingURL=validators.js.map